import React from "react";
import IconQilu from '@/images/h5-common/logo_qilu.webp';
import IconHuiya from '@/images/h5-common/logo_huiya.webp';
import { IS_HUIYA, getSiteName } from '../../config/domain';

function AboutApp() {
  // 根据域名获取网站名称
  const siteName = getSiteName();
  
  // 根据域名获取ICP备案信息
  const icpInfo = IS_HUIYA ? '鲁ICP备2025159456号-2A' : '沪ICP备2024071020号-3A';
  
  // 根据域名选择logo
  const logoIcon = IS_HUIYA ? IconHuiya : IconQilu;
  
  return (
      <div className='flex flex-col items-center ml-[20px] mr-[20px]'>
        {(
          <img
              src={logoIcon}
              alt={`${siteName} logo`}
              className='object-cover w-[90px] h-[90px] mt-[32px] mb-[32px]'
          />
        )}
        <div className='flex flex-col text-[#333333] text-[14px] font-normal'>
          "{siteName}"是一款专为英语学习定制的互动体验软件，它利用创新技术和AI辅助发音工具，创造了一个轻松愉悦的环境，帮助大家在探索中拓展英语能力。我们致力于打破传统的语言训练方式，让过程更加生动和高效。
          <br/><br/>
          【多样化互动体验】
          我们提供了一系列互动体验，包括词卡记忆游戏、拼写挑战、听力填空等，这些游戏化的方式不仅能够激发大家的好奇心，还能有效加强大家的语言感知能力。
          <br/><br/>
          
          {/* 奇鹿特有内容 */}
          <div className="deerbook-only">
            {/* 【奇鹿特有功能】
            为奇鹿用户提供的专属功能，包括更多的学习资源和进阶内容。
            <br/><br/> */}
          </div>
          
          {/* 绘芽特有内容 */}
          <div className="huiya-only">
            {/* 【绘芽特色服务】
            绘芽平台独有的优质服务，为用户提供更专业的英语学习辅导。
            <br/><br/> */}
          </div>
          
          【个性化拓展计划】
          利用智能算法，我们为大家定制了个性化的拓展计划，确保大家在探索过程中既有序又高效，帮助大家逐步建立起坚实的语言基础。
          <br/><br/>
          【智能AI助手】
          我们的App内置了AI发音辅助功能，能够提供即时的发音反馈。无论是单个音节还是完整句子，智能AI助手都能协助大家改善发音，提升语言的自然度。
          <br/><br/>
        </div>
        <div className='text-[#333333] text-[14px] font-normal'>
          {IS_HUIYA ? '青岛莫等闲创意信息科技有限公司' : '上海鹿奇飞科技发展有限公司'} 版权所有
        </div>
        <div className='text-[#333333] text-[14px] font-normal mb-[20px]'>
          {icpInfo}
        </div>

      </div>
  );
}

export default AboutApp;
